const _ = require('lodash')

// https://webpack.js.org/guides/dependency-management/#require-context
const requireModule = require.context(
  // Search for files in the current directory
  '.',
  // Search for files in subdirectories
  true,
  // Include any .generic.vue files
  /(.app.vue)$/
)

function Install (Vue, options = {}) {
  let prefix = options.prefix || 'g'
  let files = _.sortBy(requireModule.keys(), el => {
    return el.split('/').length
  })

  files.forEach(fileName => {
    // Skip this file, as it's not a comp
    if (fileName === './' || fileName === './index.js') return

    // Get the comp path as an array
    let compPath = fileName
      // Remove the "./" from the beginning
      .replace(/^\.\//, '')
      // Remove the file extension from the end (.vue)
      .replace(/\.\w+$/, '')
      // Remove the file extension from the end (.generic)
      .replace(/\.\w+$/, '')
      // Split nested comps into an array path
      .split(/\//)
      // camelCase all comp namespaces and names
      .map(n => `${prefix}_${n}`)
      .map(_.camelCase)

    let name = compPath.pop()
    let comp = requireModule(fileName).default
    Vue.component(name, comp)
  })
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(Install)
}

export default Install
